/**
 * Analytics events (point 32). No-ops until a GA4 measurement ID is set
 * via REACT_APP_GA_ID — never sends personal data.
 */
const GA_ID = process.env.REACT_APP_GA_ID;

let booted = false;
function boot() {
  if (booted || !GA_ID) return;
  booted = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

export function track(event, params = {}) {
  if (!GA_ID) return;
  boot();
  if (window.gtag) window.gtag("event", event, params);
}
